// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image[data-v-994990dc]{cursor:pointer}.media[data-v-994990dc]{margin:0!important;padding:.5rem}.media[data-v-994990dc]:nth-child(2n){background:#fafafa}.media[data-v-994990dc]:hover{background:#f5f5f5}.search-description[data-v-994990dc]{margin-top:.5rem}.identifier-text[data-v-994990dc]{font-style:oblique}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
